module.exports = "/assets/8979254ef7d9d46dbf51100b585cdbc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UN.png
// module id = 3016
// module chunks = 0